// extracted by mini-css-extract-plugin
module.exports = {"Features":"Features_Features__3BN1E"};